// extracted by mini-css-extract-plugin
module.exports = {"root":"TitleBlock_root__ndmJT","root_line":"TitleBlock_root_line__MXcEd","root_button":"TitleBlock_root_button__XWiOD"};